import { css, Interpolation, Theme } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text, Truncated } from '@frontend/design-system';

type Props = {
  iconName: IconName;
  title: string;
  subtitle?: string;
  secondaryText?: string;
  endAdornment?: React.ReactNode;
  containerStyles?: Interpolation<Theme>;
};

export const EventTypeItemBox = ({
  iconName,
  title,
  subtitle,
  secondaryText,
  endAdornment,
  containerStyles,
}: Props) => {
  const gridTemplateColumns = secondaryText
    ? 'max-content 1fr max-content max-content max-content'
    : 'max-content 1fr max-content max-content';

  return (
    <div className='event-type-box event-box' css={[styles, containerStyles, css({ gridTemplateColumns })]}>
      <Icon name={iconName} css={{ color: theme.colors.neutral70 }} />

      <div className='col-2'>
        <Truncated textAlign='left' as={Text} weight='bold' size='medium'>
          {title}
        </Truncated>
        {subtitle && (
          <Truncated textAlign='left' as={Text} size='medium'>
            {subtitle}
          </Truncated>
        )}
      </div>

      {secondaryText && (
        <Text size='medium' color='light'>
          {secondaryText}
        </Text>
      )}

      <Text as='div' size='medium'>
        {endAdornment}
      </Text>
    </div>
  );
};

const styles = css`
  padding: ${theme.spacing(2)};
  padding-right: 0;
  box-shadow: ${theme.shadows.light};
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  display: grid;
  gap: ${theme.spacing(2)};
  width: 100%;
  align-items: center;
  position: relative;

  .col-2 {
    display: grid;
    grid-template-rows: auto auto;
    justify-content: start;
  }
`;
